/*
 * @Author: ze.wang@diact.com
 * @Date: 2022-11-27 16:11:07
 * @Function: Please Input Function
 */
const genAnswer = function (qu, value) {
  // 上传的文件列表
  return value.map((v,vI) => {
    return {
      openAnswer: v.openAnswer, // 文本内容
      answer: v.url,
      otherAnswer: v.name,
      extendsData: {
        uid: v.uid,
        type: v.type,
        length: v.length,
        voiceAnswerType: v.openAnswer ? undefined : 'LINK'
      }
    }
  })
}

const setAnswer = function (qu, valueMap, otherAnswerMap, extendsDataMap, answerList = []) {
  // 断点续答初始化文件列表
  this.value = answerList.length && answerList.map(answer => {
      return {
        openAnswer: answer.openAnswer, // 文本内容
        url: answer.answer,
        name: answer.otherAnswer,

        uid: answer.extendsData && answer.extendsData.uid,
        type: answer.extendsData && answer.extendsData.type,
        length: answer.extendsData && answer.extendsData.length,
        voiceAnswerType: answer.extendsData && answer.extendsData.voiceAnswerType,
      }
  })
}

const answer = {
  genAnswer,
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/MusicBox/answer.js